export const myDocumentsState = {
  documents: [],
  isLoading: false,
  searchTerm: null
};
